import React, { FC, useState, useEffect, memo, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import ConfirmDialog from "../../ui/ConfirmDialog";
import InputText from "../../ui/InputText";
import ListItem from "../../ui/ListItem";
import MessageEditor from "../message/messageEditor";
import { ContactsApi } from "../restapi/contactsApi";
import worker from "../setupWorker";
import store from "../store";
import LotCheckBox from "../ui/lotCheckBox";
import MyTextInput from "../ui/myTextInput";
import { GetUserID } from "../utils/common";

type OwnProps = {

}

const DanhSachNhomTele: FC<OwnProps> = ({

}) => {
    const ref = useRef<HTMLDivElement>(null)
    const [state, setState] = useState({
        danhSachNhom: [] as any,
        textToSend: "",
        sendMsgOpen: false,
    })
    useEffect(() => {
        ContactsApi.getDanhSachNhomTele().then(res => {
            const tmp: any[] = res.data
            // for (let i = 0; i < 100; i++) {
            //     tmp.push([...res.data])
            // }
            if (res.data) {
                setState(prev => ({ ...prev, danhSachNhom: tmp }))
            }
        })
    }, [])
    function sendMessageToAllGroup() {

    }
    return (
        < >
            <div className=" lot-toolbar">
                <div className=" lot-toolbar left-panel">

                </div>
                <div className=" lot-toolbar right-panel">
                    {/* <Button round size="tiny" color="secondary"> <i className="icon icon-check"></i></Button> */}
                    <Button round size="tiny" color="secondary"
                        onClick={() => setState(prev => ({ ...prev, sendMsgOpen: true }))}
                    > <i className="icon icon-send"></i></Button>
                </div>
            </div>
            {
                state.danhSachNhom.filter((it: any) => it.title != "").map((item: any) => {
                    return (<ListItem >
                        <div> {item.title}.</div>

                    </ListItem>)
                })
            }
            <ConfirmDialog title="Gửi tin nhắn"
                text="Gửi tin nhắn tới tất cả các nhóm"
                confirmLabel="Gửi tin"
                confirmHandler={() => {
                    const text = ref.current!.innerText                    
                    if (text.trim() == "") {
                        worker.postMessage({ type: 'showsnackbar', data: 'Nội dung tin không được để trống' })
                        return
                    }
                    setState(prev => ({ ...prev, sendMsgOpen: false }))
                    const payload = { text: text }
                    ContactsApi.sendMsgToAllGroup(payload).then(res => {
                        worker.postMessage({ type: 'showsnackbar', data: res.data })
                    })
                }}
                onClose={() => setState(prev => ({ ...prev, sendMsgOpen: false }))}
                isOpen={state.sendMsgOpen}
            >
                <div contentEditable={true} ref={ref} className=" editable-div">

                </div>
            </ConfirmDialog>
        </ >
    )
}
export default memo(DanhSachNhomTele)